
define('app/dashboard/dashboardMain',[
	'domReady',
	'app/dashboard/dashboardApp',
	'app/common/setup'
], function(domReady, DashboardApp, Setup){
	domReady(function () {
		Setup.initialize();
		DashboardApp.initialize();
    });
});